<template>
    <b-navbar toggleable="lg" type="light bg-light">
        <b-navbar-brand href="#">
            <img src="data:image/png;base64,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"
                width="30" height="30" class="d-inline-block align-top" alt="">
            Compendium CMS
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item to="/" v-if="user" exact class="comp-yellow">Disciplines</b-nav-item>
                <b-nav-item :to="{ name: 'QuestionPerDiscipline', params: { id: 1 } }" v-if="user" exact
                    class="comp-red">Questions</b-nav-item>
                <b-nav-item to="/import" v-if="user" class="comp-purple">Import</b-nav-item>
                <b-nav-item to="/media" v-if="user" class="comp-blue">Media</b-nav-item>
                <b-nav-item to="/battles" v-if="user" exact class="comp-green">Battle</b-nav-item>
                <!-- <b-nav-item to="/users" v-if="user" exact class="comp-yellow">Users</b-nav-item> -->
                <b-nav-item-dropdown v-if="user" exact class="comp-yellow" text="Users">
                    <b-dropdown-item to="/users">Users</b-dropdown-item>
                    <b-dropdown-item to="/vouchers">Vouchers</b-dropdown-item>
                    <b-dropdown-item to="/subscriptions">Subscriptions</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item to="/promos" v-if="user" exact class="comp-red">Promos</b-nav-item>
                <!-- <b-nav-item to="/vouchers" v-if="user" exact class="comp-purple">Vouchers</b-nav-item> -->
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item to="/login" v-if="!user">Log in</b-nav-item>
                <b-nav-item to="/register" v-if="!user && !production">Register</b-nav-item>
                <b-nav-item @click="logout" v-if="user">Log out</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';

export default {
    name: 'NavBar',
    data() {
        return {
            user: null,
            production: process.env.NODE_ENV === 'production'
        };
    },
    created() {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            this.user = user;
        });
    },
    methods: {
        logout() {
            const auth = getAuth();
            signOut(auth).then(() => {
                // Handle successful logout
                this.$router.push('/login');
            }).catch((error) => {
                // Handle logout errors
                console.log(error);
            });
        }
    }
};
</script>

<style>
.nav-link {
    color: rgb(0 0 0 / 53%);
    display: inline-block;
    margin: 3px;
    border-radius: 8px;
    padding: 0.5em 1em !important;
}

.nav-link a {
    padding: 0.5em 1em;
}

.router-link-active {
    color: #fff !important;
    font-weight: bold;
    background: #6e6c6c;
    border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}

.comp-yellow .router-link-active {
    background: var(--color-yellow);
}

.comp-red .router-link-active {
    background: var(--color-red);
}

.comp-purple .router-link-active {
    background: var(--color-purple);
}

.comp-blue .router-link-active {
    background: var(--color-blue);
}

.comp-green .router-link-active {
    background: var(--color-green);
}

.ml-auto {
    margin-left: auto;
}
</style>
